import { BellRing, Smartphone } from 'lucide-react';

export interface PushSubscriptionBannerProps {
  variant: 'inline' | 'compact';
  pushState: 'unsupported' | 'denied' | 'default' | 'subscribed';
  onSubscribe: () => void;
  isLoading?: boolean;
}

export function PushSubscriptionBanner({
  variant,
  pushState,
  onSubscribe,
  isLoading,
}: PushSubscriptionBannerProps) {
  if (pushState === 'subscribed') return null;

  const isUnsupported = pushState === 'unsupported';
  const isDenied = pushState === 'denied';
  const canEnable = pushState === 'default';

  const tone = isUnsupported ? 'bg-surface-soft' : isDenied ? 'bg-danger-soft' : 'bg-warn-soft';

  const containerClass =
    variant === 'compact'
      ? `w-full flex items-center gap-3 px-4 py-3 border-line border-b text-right ${tone}`
      : `w-full flex items-center gap-3 p-3 mb-4 rounded-card text-right ${tone}`;

  return (
    <div className={containerClass}>
      {isUnsupported ? (
        <Smartphone className="text-muted h-5 w-5 flex-shrink-0" />
      ) : (
        <BellRing className={`h-5 w-5 flex-shrink-0 ${isDenied ? 'text-danger' : 'text-warn'}`} />
      )}
      <div className={variant === 'compact' ? 'min-w-0 flex-1' : 'flex-1'}>
        {isUnsupported && (
          <>
            <p className="text-ink-2 text-sm font-bold">הוסף למסך הבית</p>
            <p className="text-muted text-xs">
              התראות עובדות רק כשנפתחים מהמסך הראשי. הוסף את האפליקציה למסך הבית.
            </p>
          </>
        )}
        {isDenied && (
          <>
            <p className="text-danger text-sm font-bold">התראות חסומות</p>
            <p className="text-danger/80 text-xs">
              עבור להגדרות → Safari → אתר זה → התראות כדי לאפשר.
            </p>
          </>
        )}
        {canEnable && (
          <button
            onClick={onSubscribe}
            disabled={isLoading}
            className="w-full text-right transition-[opacity,transform] hover:opacity-80 active:scale-[0.96] disabled:opacity-70 disabled:active:scale-100"
          >
            <p className="text-warn text-sm font-bold">הפעל התראות פוש</p>
            <p className="text-warn/80 text-xs">לחץ כאן כדי לקבל התראות גם כשהאפליקציה סגורה</p>
          </button>
        )}
      </div>
    </div>
  );
}
